import { css } from "../../../styled-system/css";
import { vstack } from "../../../styled-system/patterns";
import svgError from "../../assets/icons/error.svg";
import { SquareButton } from "../../components/buttons/squareButton/SquareButton";

export function Error() {
  return (
    <div className={vstack({ width: "100%", gap: 0, pt: "160px" })}>
      <div
        className={vstack({
          gap: "32px 0",
          justifyContent: "center",
          py: 5,
          color: "text.lighten",
        })}
      >
        <img src={svgError} alt="" className={css({ w: 40, h: 40 })} />
        <div className={vstack({ gap: "8px 0" })}>
          <span className={css({ textStyle: "span.l.bold" })}>
            Not&nbsp;Found
          </span>
          <span className={css({ textStyle: "paragraph.m" })}>
            こちらのページは存在しないURLです
          </span>
        </div>
        <button
          className={css({
            cursor: "pointer",
            textStyle: "span.m.regular",
            textDecoration: "underline",
            color: "text.lighten",
          })}
          onClick={() => {
            history.back();
          }}
        >
          商品ページに戻る
        </button>
      </div>

      <div
        className={css({
          bg: "black.100",
          width: "100%",
          px: 3,
          position: "fixed",
          bottom: 0,
          left: 0,
          pt: 2,
          height: "134px",
          boxShadow: "0px 4px 15px 0px #00000040",
          zIndex: "stickeyFooter",
        })}
      >
        <div
          className={css({
            width: "100%",
            maxWidth: "760px",
            mx: "auto",
            textAlign: "center",
          })}
        >
          <SquareButton
            size="full"
            variant="contained"
            color="primary"
            disabled
          >
            次へ
          </SquareButton>
          <button
            className={css({ mt: 2, textStyle: "button.m" })}
            onClick={() => {
              history.back();
            }}
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
}
